import BaseTypeController from "vamos/cockpit/base/controller/BaseTypeController";
import JSONModel from "sap/ui/model/json/JSONModel";
import Dialog from "sap/m/Dialog";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";
import PositionDialogInterface from "vamos/cockpit/data/masterdata/bmecat/discontinueditems/model/PositionDialogInterface";
import Table from "sap/ui/table/Table";

/**
 * @namespace vamos.cockpit.data.masterdata.bmecat.discontinueditems.controller
 * */
export default class RequestPositionDialogController extends BaseTypeController {
    private dialog: Dialog;
    private dialogModel: JSONModel = new JSONModel({});
    private table: Table;


    onInit(): void {
        super.onInit();

        this.dialog = this.getView().byId("requestPositionDialog") as Dialog;
        this.table = this.getView().byId("requestPositionTable") as Table;
        this.getView().setModel(this.dialogModel, "data");

    }

    public openDialog(data: PositionDialogInterface): void {
        this.dialogModel.setData(data);
        const filter = new Filter([
            new Filter("ProductGuid", FilterOperator.EQ, data.productGuid),
            new Filter("Extracted", FilterOperator.EQ, false),
            new Filter("Canceled", FilterOperator.EQ, false)
        ],true);

        this.table.bindRows({
            path: "/RequestPositions",
            filters: [filter],
        });
        this.dialog.open();
    }

    public onClose(): void {
        this.dialog.close();
    }


}